import React from 'react';
import '../styles.css';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const SnackToast = ({ popOn, message,severity, handleClose }) => (
  <>
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={popOn === true ? 'open' : ''}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  </>
);
export default SnackToast;
